// Mock data for NEXUS FX PRO clone

export const NAV_LINKS = [
  {
    label: 'Introduction',
    items: ['Why NEXUS FX PRO', 'Regulation', 'Security', 'About Us']
  },
  {
    label: 'Trade & Invest',
    items: ['Forex', 'Commodities', 'Indices', 'Stocks (CFDs)', 'Cryptocurrencies']
  },
  {
    label: 'Products',
    items: ['Standard Account', 'Premium Account', 'Elite Account', 'Copy Trading', 'PAMM']
  },
  {
    label: 'Tools',
    items: ['cTrader Platform', 'WebTrader', 'Mobile App', 'Marketplace', 'Indicators']
  },
  {
    label: 'Learn',
    items: ['Trading Academy', 'Webinars', 'Education', 'Market Analysis']
  },
  {
    label: 'Company',
    items: ['About Us', 'Partners', 'Careers', 'Contact', 'Press']
  }
];

export const HERO_TICKERS = ['Forex', 'Commodities', 'Stocks (CFDs)', 'Cryptocurrencies', 'Indices'];

export const PRICE_TICKER = [
  { symbol: 'EUR/USD', price: 1.0821, change: 0.14 },
  { symbol: 'GBP/USD', price: 1.2655, change: -0.22 },
  { symbol: 'USD/JPY', price: 149.822, change: 0.38 },
  { symbol: 'AUD/USD', price: 0.6572, change: -0.11 },
  { symbol: 'NZD/USD', price: 0.5941, change: 0.09 },
  { symbol: 'USD/CAD', price: 1.3611, change: -0.05 },
  { symbol: 'BTC/USD', price: 68222.15, change: 1.74 },
  { symbol: 'ETH/USD', price: 3831.4, change: 0.48 },
  { symbol: 'XAU/USD', price: 2412.55, change: 0.32 },
  { symbol: 'US30', price: 39218.4, change: -0.18 },
  { symbol: 'NAS100', price: 18654.9, change: 0.42 },
  { symbol: 'SPX500', price: 5205.1, change: 0.11 },
  { symbol: 'UK100', price: 8125.7, change: -0.05 },
  { symbol: 'DE40', price: 18025.8, change: 0.28 }
];

export const STATS = [
  { value: '$1.2B+', label: 'Daily Trading Volume' },
  { value: '150+', label: 'Countries Served' },
  { value: '1.2K+', label: 'Tradeable Instruments' },
  { value: '99.99%', label: 'Platform Uptime' }
];

export const FEATURES = [
  { tag: 'Support', title: '24/7 Human Support', desc: 'Talk to real trading experts anytime via live chat, email, or phone. Fast, reliable human assistance whenever you need it.', icon: 'Headphones' },
  { tag: 'Withdrawals', title: 'Withdrawals in as Little as 15 Minutes', desc: 'Experience lightning-fast withdrawals with quick processing designed to give you faster access to your funds.', icon: 'Zap' },
  { tag: 'AI', title: 'AI-Powered Trading Assistance', desc: 'Trade smarter using ChatGPT, DeepSeek, AI Agents, and intelligent automation to assist with market research.', icon: 'Sparkles' },
  { tag: 'Indicators', title: '100+ Smart Indicators', desc: 'Access 100+ professional indicators including SuperTrend, Market Sessions, Smart Money Concepts, and more.', icon: 'LineChart' },
  { tag: 'Automation', title: '100+ Free Trading Bots', desc: 'Automate your strategies with over 100 free trading bots designed to improve execution and trading efficiency.', icon: 'Bot' },
  { tag: 'Platform', title: 'Advanced cTrader Trading Platform', desc: 'Trade on the powerful cTrader platform with advanced charting, lightning-fast execution, and algorithmic trading.', icon: 'Monitor' },
  { tag: 'Markets', title: '1,200+ Tradable Instruments', desc: 'Trade Forex, Indices, Commodities, Stocks, ETFs, Cryptocurrencies, and more from one account.', icon: 'Globe2' },
  { tag: 'Copy Trading', title: 'Advanced Copy Trading & PAMM', desc: 'Follow experienced traders or invest through professional PAMM solutions with transparency and flexibility.', icon: 'Users' },
  { tag: 'Risk Management', title: 'Advanced Risk Management Tools', desc: 'Protect your capital using built-in calculators, position sizing tools, risk analysis, and trade management.', icon: 'ShieldCheck' },
  { tag: 'Partners', title: 'High-Reward Partnership Program', desc: 'Earn up to 70% revenue share with transparent commission tracking and instant partner payouts.', icon: 'Handshake' }
];

export const ACCOUNTS = [
  {
    name: 'Standard Account',
    price: '$0',
    priceLabel: 'Commission',
    popular: false,
    features: [
      'Account Currencies: USD / GBP / EUR',
      'Leverage: Up to 1:500',
      '1,200+ Tradable Instruments',
      'Spreads: Starts From 0.8 pips',
      'Commission: None',
      'Minimum Deposit: $20',
      'Maximum Deposit: No Limit',
      'Expert Advisors (EA/Bots): Supported'
    ]
  },
  {
    name: 'Premium Account',
    price: '$8',
    priceLabel: 'per Lot',
    popular: true,
    features: [
      'Account Currencies: USD / GBP / EUR',
      'Leverage: Up to 1:500',
      '1,200+ Tradable Instruments',
      'Spreads: Starts From 0 pips',
      'Commission: $8 per Lot',
      'Minimum Deposit: $1,000',
      'Maximum Deposit: No Limit',
      'Expert Advisors (EA/Bots): Supported'
    ]
  },
  {
    name: 'Elite Account',
    price: 'Custom',
    priceLabel: 'Solutions',
    popular: false,
    features: [
      'Leverage: Customized',
      'Tradable Instruments: 1,200+',
      'Spreads: Customized',
      'Commission: Customized',
      'Minimum Deposit: $2,000',
      'Maximum Deposit: No Limit',
      'Expert Advisors (EAs/Bots): Allowed',
      'Dedicated Account Manager'
    ]
  }
];

export const TESTIMONIALS = [
  { name: 'Rahul M.', role: 'Forex Trader', initials: 'RM', text: 'NEXUS FX PRO has transformed my trading. The execution speed is incredible \u2014 no slippage, no requotes. I moved my entire portfolio here within a month.' },
  { name: 'Priya S.', role: 'Scalper', initials: 'PS', text: 'The spreads are genuinely tight. I trade gold daily and the difference versus my old broker is measurable. Customer support is very responsive.' },
  { name: 'James T.', role: 'Algo Trader', initials: 'JT', text: 'Finally a platform that feels institutional. The MT5 integration is seamless and their VPS service keeps my EAs running 24/7 without issues.' },
  { name: 'Ahmed K.', role: 'Portfolio Manager', initials: 'AK', text: 'The leverage options and asset variety are exceptional. I can trade indices, forex, and commodities all from one account. Highly recommended.' },
  { name: 'Sofia L.', role: 'Prop Firm Trader', initials: 'SL', text: 'Regulation and transparency were my top concerns. NEXUS FX PRO checks every box. Withdrawals are fast, reporting is clear, the team is professional.' },
  { name: 'Kevin O.', role: 'Day Trader', initials: 'KO', text: 'Their mobile app is best-in-class. I manage positions on the go without compromising on charting tools or execution quality.' },
  { name: 'Maria J.', role: 'IB Partner', initials: 'MJ', text: 'Switched from a major broker after trying NEXUS FX PRO\u2019s demo. The platform performance, account types, and IB program are all superior.' },
  { name: 'Yuki T.', role: 'News Trader', initials: 'YT', text: 'Excellent for news trading. Their eco system handles high volatility well \u2014 execution stays crisp even during major economic events.' }
];

export const DIFFERENCE_ITEMS = [
  { title: 'We Want You to Succeed', desc: 'From developing the best educational materials, to providing daily market analysis updates and live webinars, we are as interested in your success as you are.' },
  { title: 'We Believe in Endless Possibilities', desc: "Access the world's most popular instruments, ranging from forex pairs to CFDs on stocks, indices, commodities, and cryptocurrencies \u2014 all at the palm of your hand." },
  { title: 'Great Trading Conditions', desc: 'Hedging is allowed, without any restrictions on short selling and scalping. We provide fast and reliable order execution and ultra-low spreads.' },
  { title: 'We Believe You Deserve The Best', desc: 'Take advantage of our Expert Advisors, Copy Trading platforms and 24/7 crypto trading, or utilise the Trading Central automated analysis add-on.' },
  { title: 'We Love to Stay in Touch!', desc: 'Stay up-to-date on the latest market news, promotions and offers. Follow us on our social media channels for real-time market updates.' },
  { title: 'Secure & Transparent', desc: 'Trade with confidence using strong platform protections and clear policies \u2014 built around privacy, risk controls, and reliable infrastructure.' }
];

export const LEARN_CARDS = [
  { tag: 'LEARN', title: 'Trading Academy', desc: 'Learn with NEXUS FX PRO Academy for clear, structured lessons. Easy steps to build trading skills. No experience needed.', cta: 'Explore Courses' },
  { tag: 'READ', title: 'Education Section', desc: 'Read articles and watch tutorials that cover every trading aspect. All topics, all levels, all in one click.', cta: 'Browse All Topics' },
  { tag: 'WATCH', title: 'Live Webinars', desc: 'Attend our weekly live webinars to analyse trends. Improve your trading skills, in simple and understandable terms.', cta: 'Reserve Your Spot' }
];

export const PLATFORMS = [
  { title: 'Advanced Web Terminal', desc: 'Institutional-grade web trading with sub-second execution and pro tools.' },
  { title: 'TradingView Integration', desc: 'Trade directly from TradingView charts with your NEXUS FX PRO account seamlessly.' },
  { title: 'WebTrader', desc: 'Fast, lightweight browser platform \u2014 no installation required.' },
  { title: 'Mobile Trading App', desc: 'Manage positions on the go with our iOS and Android native apps.' }
];

// Dashboard mock data
export const DASHBOARD_STATS = {
  balance: 25842.16,
  equity: 26105.42,
  margin: 1204.55,
  freeMargin: 24900.87,
  marginLevel: 2167.34,
  pnl: 263.26,
  pnlPct: 1.03
};

export const OPEN_POSITIONS = [
  { id: 1, symbol: 'EUR/USD', type: 'Buy', volume: 0.5, open: 1.0805, current: 1.0821, pnl: 80.00, sl: 1.0780, tp: 1.0870 },
  { id: 2, symbol: 'XAU/USD', type: 'Buy', volume: 0.2, open: 2402.10, current: 2412.55, pnl: 209.00, sl: 2390.00, tp: 2440.00 },
  { id: 3, symbol: 'GBP/USD', type: 'Sell', volume: 0.3, open: 1.2680, current: 1.2655, pnl: 75.00, sl: 1.2720, tp: 1.2600 },
  { id: 4, symbol: 'BTC/USD', type: 'Buy', volume: 0.05, open: 67850.00, current: 68222.15, pnl: 18.61, sl: 67000.00, tp: 70000.00 },
  { id: 5, symbol: 'NAS100', type: 'Sell', volume: 1.0, open: 18720.5, current: 18654.9, pnl: 65.60, sl: 18800.0, tp: 18500.0 }
];

export const RECENT_TRADES = [
  { id: 101, symbol: 'EUR/USD', type: 'Buy', volume: 1.0, open: 1.0790, close: 1.0812, pnl: 220.00, date: '2025-07-24' },
  { id: 102, symbol: 'USD/JPY', type: 'Sell', volume: 0.8, open: 150.20, close: 149.95, pnl: 133.55, date: '2025-07-23' },
  { id: 103, symbol: 'XAU/USD', type: 'Buy', volume: 0.1, open: 2385.00, close: 2402.00, pnl: 170.00, date: '2025-07-22' },
  { id: 104, symbol: 'BTC/USD', type: 'Sell', volume: 0.02, open: 68500.00, close: 67800.00, pnl: 14.00, date: '2025-07-21' },
  { id: 105, symbol: 'GBP/JPY', type: 'Buy', volume: 0.5, open: 190.55, close: 190.20, pnl: -117.20, date: '2025-07-20' }
];

export const WATCHLIST = [
  { symbol: 'EUR/USD', bid: 1.0820, ask: 1.0822, spread: 0.2, change: 0.14 },
  { symbol: 'GBP/USD', bid: 1.2654, ask: 1.2656, spread: 0.2, change: -0.22 },
  { symbol: 'USD/JPY', bid: 149.820, ask: 149.824, spread: 0.4, change: 0.38 },
  { symbol: 'XAU/USD', bid: 2412.45, ask: 2412.65, spread: 0.2, change: 0.32 },
  { symbol: 'BTC/USD', bid: 68220.00, ask: 68225.00, spread: 5.0, change: 1.74 },
  { symbol: 'NAS100', bid: 18654.5, ask: 18655.3, spread: 0.8, change: 0.42 },
  { symbol: 'US30', bid: 39218.0, ask: 39219.5, spread: 1.5, change: -0.18 },
  { symbol: 'ETH/USD', bid: 3831.10, ask: 3831.70, spread: 0.6, change: 0.48 }
];
